export default {"src":"/_next/static/media/calendar.460c1914.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};